import { SkApolloRequest } from 'utils/apolloUtils';
import {
  FETCH_ENRICHMENT_PAYNOW_CONFIG,
  UPDATE_ENRICHMENT_PAYNOW_CONFIG,
} from '../models/configModels';
import SkRequest from './BaseRequest';
import { MutationBuilder } from '../queryBuilder';

const _mMutationBuilder = new MutationBuilder();

_mMutationBuilder.setNewMutation('updateSchoolConfig', {
  ID: 'number',
  key: 'string',
  value: 'string',
});

_mMutationBuilder.setNewMutation('getSchoolLogoUploadURL', {
  Url: 'string',
  Key: 'string',
});

export const updateSchoolConfig = reqData => async () => {
  const query = _mMutationBuilder.getBulkMutationAsString({
    updateSchoolConfig: reqData,
  });
  try {
    const data = await SkRequest({
      data: {
        query,
      },
      method: 'POST',
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export const getSchoolLogoUploadURL = reqData => async () => {
  const query = _mMutationBuilder.getMutationAsString(
    'getSchoolLogoUploadURL',
    reqData
  );

  try {
    const data = await SkRequest({
      data: {
        query,
      },
      method: 'POST',
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export const getEnrichmentPayNowConfig = async () => {
  const data = await SkApolloRequest({
    params: {
      query: FETCH_ENRICHMENT_PAYNOW_CONFIG,
    },
    type: 'query',
  });
  return data;
};

export const updateEnrichmentPayNowConfig = async reqData => {
  const data = await SkApolloRequest({
    params: {
      mutation: UPDATE_ENRICHMENT_PAYNOW_CONFIG,
      variables: reqData,
    },
    type: 'mutation',
  });
  return data;
};

export default updateSchoolConfig;
